module.exports = __webpack_public_path__ + "static/img/DSC_2704.96c14f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2704.jpg
// module id = 280
// module chunks = 0